exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-breadcrumbs{position:relative;margin-bottom:20px}.breadcrumbs{font-weight:400;font-size:13px;line-height:18px}.breadcrumbs .item{position:relative;display:inline-block;margin-right:8px;vertical-align:top;overflow:hidden}.breadcrumbs .item:not(:last-child):after{color:#e0e3e4;font-size:13px;position:relative;display:inline-block;margin-left:8px;right:0;top:-1px;content:\"\\203A\"}.breadcrumbs .popup{position:absolute;top:0;opacity:0;z-index:-10}", ""]);

// exports
